import type { MarketResponseDto } from "Infrastructure/Api/Api";
import { useMarketRegionList } from "Market/Api/Query/useMarketRegionList";
import { RegionListItemForm } from "Market/Components/Form/RegionListItemForm";
import { RegionCardCreateWidget } from "Market/Widgets/RegionCardCreateWidget";
import { Box, Divider, Stack } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router";

type RegionsTabProps = {
	market: MarketResponseDto;
	urlPath: string;
};

export const MarketRegionsTab = ({ market, urlPath }: RegionsTabProps) => {
	const { data: regions } = useMarketRegionList(market.id);
	const { data: deletedRegions } = useMarketRegionList(market.id, true);
	const [showDeleted, setShowDeleted] = useState(false);

	const sortByName = <T extends { name: string }>(items: T[] | undefined) =>
		items?.slice().sort((a, b) => a.name.localeCompare(b.name));

	return (
		<Stack rowGap={2}>
			{sortByName(regions)?.map((region) => {
				return <RegionListItemForm key={region.id} region={region} />;
			})}
			{(deletedRegions?.length ?? 0) > 0 && (
				<>
					{showDeleted && (
						<>
							<Divider />
							{sortByName(deletedRegions)?.map((deleted) => {
								return <RegionListItemForm key={deleted.id} region={deleted} />;
							})}
						</>
					)}
					<Stack alignItems="end">
						<Link
							to={""}
							color="primary"
							onClick={() => {
								setShowDeleted(!showDeleted);
							}}
						>
							{showDeleted ? "Hide Deleted" : "Show Deleted"}
						</Link>
					</Stack>
				</>
			)}
			<Box>
				<RegionCardCreateWidget urlPath={urlPath} marketId={market.id} />
			</Box>
		</Stack>
	);
};
